import {useMemo} from 'react';

import {useHelpLinks} from '../../../provider/help-links/help-links-hook';
import {HelpLinkFeatureFlagEnum} from '../../feature-flags/feature-flag-const';

import {parseReviewRealtimeHelpLinkConfig, ReviewRealtimeHelpLinkConfigType} from './review-realtime-presence-config';

export function useReviewRealtimeConfig(): ReviewRealtimeHelpLinkConfigType | null {
    const helpLinks = useHelpLinks();

    return useMemo(() => {
        const helpLink = helpLinks.find((link) => link.urlPattern === HelpLinkFeatureFlagEnum.reviewRealtime);

        if (!helpLink) {
            return null;
        }

        return parseReviewRealtimeHelpLinkConfig(helpLink.config);
    }, [helpLinks]);
}
